import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { RoutesEnum } from 'src/app/enums/routes-enum';

import { Balance } from 'src/app/models/balance';
import { AuthService } from 'src/app/services/auth.service';
import { SoldeService } from 'src/app/services/solde.service';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-solde',
  templateUrl: './solde.component.html',
  styleUrls: ['./solde.component.css'],
})
export class SoldeComponent implements OnInit {
  data: Balance[] = [];
  sum: number = 0;
  account!: string;
  tickets: string[] = [];

  constructor(
    private soldeService: SoldeService,
    private authService: AuthService,
    private ticketService: TicketService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authService
      .getUserInfos('company')
      .pipe(
        switchMap((result) => {
          this.tickets = result.data.company.tickets.map(
            (item: { label: string }) => item.label
          );

          return this.authService.getUser();
        }),
        switchMap((user) => {
          if (user.account) {
            this.account = user.account;
          } else {
            console.warn('Aucun compte trouvé.');
          }
          //this.account = user.account;
          return this.ticketService.getAllTickets();
        }),
        switchMap((response) => {
          const tickets = Array.isArray(response.tickets)
            ? response.tickets
            : [];

          const filteredTickets = tickets.filter((item) =>
            this.tickets.includes(item.label)
          );
          const balanceRequests = filteredTickets.map(
            (ticket: { id: any; label: string }) =>
              this.soldeService
                .getBalance(ticket.id, this.account)
                .pipe(
                  map(
                    (balanceResponse) =>
                      new Balance(
                        ticket.label,
                        balanceResponse.result.balance,
                        new Date()
                      )
                  )
                )
          );
          return forkJoin<Balance[]>(balanceRequests);
        })
      )
      .subscribe(
        (balances) => {
          this.data = balances;
          this.sum = balances.reduce(
            (acc, solde) => acc + Number(solde.amount),
            0
          );
        },
        (error) => {
          console.error('Erreur lors du chargement des soldes :', error);
        }
      );
  }

  showDetails(item: Balance) {
    // this.router.navigate([RoutesEnum.TransactionRouteM]);
  }
}
